import { useReducer, useState } from "react";
import { t } from '@mp/locale';
function reducer(state, action) {
    if (action.type === "NEXT") {
        return state + 1;
    }
    if (action.type === "PREVIOUS") {
        return state - 1;
    }
    if (action.type === "GOTO") {
        return action.step;
    }
}
var steps = [
    {
        name: "property_details",
    },
    {
        name: "schedule",
    },
    {
        name: "contact",
    },
    {
        name: "review",
    },
    {
        name: "checkout",
        label: t("CAPTURE_SERVICES.ORDER.STEPS.checkout.label"), // Checkout
    },
];
export function useSteps() {
    var _a = useReducer(reducer, 0), step = _a[0], setSteps = _a[1];
    var _b = useState(undefined), section = _b[0], setSection = _b[1];
    return {
        back: function () { return setSteps({ type: "PREVIOUS" }); },
        next: function () { return setSteps({ type: "NEXT" }); },
        goToStep: function (step, section) {
            setSteps({ type: "GOTO", step: step });
            setSection(section);
        },
        section: section,
        step: step,
        steps: steps,
    };
}
